<mat-card>
  <mat-card-header>
    <mat-card-title>
      <div class="device-name">{{selectedDevice.name}}</div>
      <div class="stream-close" (click)="deselectDevice()">
        <svg height="25" width="25">
          <use fill="#666" href="/angular/webforms/assets/img/camera-realtime-map/close.svg#icon"></use>
        </svg>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="state != 3">
      <span *ngIf="state != 4">Loading Stream</span>
      <span *ngIf="state == 4">Stream Error. Reconnecting</span>
    </div>

    <div *ngIf="videoFormat != 'H264' && videoFormat != ''">
      <span>H.265 live streams require m-View Live Viewer  <br />
        (not supported on web/mobile) <br />
         Some Windows PCs need codecs outside Altitude playback.</span>
    </div>
    <div  [hidden]="state != 3">
      <video #target id="player-video" class="video-js" controls muted playsinline></video>
      <mat-select [(value)]="selectedCamera" class="camera-select">
        <mat-option *ngFor="let camera of cameras" [value]="camera" [disabled]="!camera.live" [class.offline]="!camera.live">{{camera.streamName}}</mat-option>
      </mat-select>
    </div>
  </mat-card-content>



  <mat-card-footer *ngIf="state != 3">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </mat-card-footer>
</mat-card>
